export const navMap = [
  {
    id: '1',
    path: '/grade/projects',
    label: 'Проекты',
  }
];